<tt-page>
    <tt-page-heading>{{ heading }}</tt-page-heading>
    <tt-customer-edit [params]="params" (getLoaded)="onGetLoaded($event)" (submit)="onSubmit($event)"></tt-customer-edit>
</tt-page>
